var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.5C22 20.8807 20.8807 22 19.5 22C18.1193 22 17 20.8807 17 19.5C17 18.1193 18.1193 17 19.5 17C20.8807 17 22 18.1193 22 19.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2602 1.87682C1.3283 1.46824 1.71472 1.19223 2.12329 1.26032L6.45209 1.98179C7.77811 2.20279 8.75 3.35006 8.75 4.69437V7.00012H17C18.1046 7.00012 19 7.89555 19 9.00012V9.25012H8.75V10.7383C8.27009 10.6045 7.7678 10.5243 7.25 10.5047V4.69437C7.25 4.08332 6.80823 3.56183 6.20549 3.46138L1.8767 2.73991C1.46812 2.67182 1.1921 2.2854 1.2602 1.87682Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1865 19.0001H15.5309C15.7566 17.1908 17.1906 15.7567 19 15.5311V10.7501H8.79187C11.5103 11.5281 13.5 14.0317 13.5 17C13.5 17.6979 13.39 18.37 13.1865 19.0001Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22C9.76142 22 12 19.7614 12 17C12 14.2386 9.76142 12 7 12C4.23858 12 2 14.2386 2 17C2 19.7614 4.23858 22 7 22ZM7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17C9 18.1046 8.10457 19 7 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.d683d0c052dcb8ef255b245709a4a835.svg";
export { ForwardRef as ReactComponent };